import React, { memo } from 'react';
import type { FC } from 'react';
import { FormInput } from '@alfa-bank/site-form-input';

import { CODE_WORD_MAX_LENGTH, CODE_WORD_SYMBOLS_VALIDATOR } from './config';
import type { ICodeWordField } from './models';

export const CodeWordField: FC<ICodeWordField> = memo(({ caption, errorText, placeholder }) => {
    return (
        <FormInput
            isRequired
            name="codeWord"
            settings={{ caption, placeholder, maxLength: CODE_WORD_MAX_LENGTH }}
            validatorConfig={[
                {
                    reg: CODE_WORD_SYMBOLS_VALIDATOR.reg,
                    message: errorText?.symbols || CODE_WORD_SYMBOLS_VALIDATOR.message,
                },
            ]}
        />
    );
});
